'use strict';

module.exports = require('./dom-scroll-into-view');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.2.0@dom-scroll-into-view/lib/index.js
 ** module id = 71
 ** module chunks = 0
 **/